module.exports = __webpack_public_path__ + "static/Ipsita-Chowdhury.6351c82c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/Ipsita-Chowdhury.jpg
// module id = 917
// module chunks = 146520050992020